import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36045663"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"container\" data-v-36045663><div class=\"row\" data-v-36045663><div class=\"col-12\" data-v-36045663><p data-v-36045663>(c) CyberBearz Army / BearzVerse, 2022</p><a href=\"https://army.bearz.tech/\" target=\"_blank\" data-v-36045663><figure class=\"img img-cba\" data-v-36045663></figure></a></div></div></div>", 1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", null, _hoisted_2))
}